export const LoadingStates = {
  OTP: "sending otp.....",
  GOOGLE: "initiating google login",
  EMAIL: "verifying email",
  PHONE: "verifying phone number",
  PASSWORD: "validating password",
  PROFILE: "updating profile",
  SESSION: "checking session",
  DATA: "fetching data",
  UPLOAD: "uploading file",
  SUBMIT: "submitting form",
  EMPTY: "",
} as const;
